import { SnackBarService } from "@teammood/shared/ui/snack-bar";
import { IntercomService } from '@teammood/shared/util/intercom';
import { UserService } from 'app/frontend/lib/shared/util/user';
import {IntegrationsService} from "../../setup/integrations/integrations.service";
import { Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { LoggerService } from "@teammood/shared/util/logger";

@Component({
    selector: 'ready',
    templateUrl: './ready.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class ReadyComponent implements OnInit{
    
    teamId: string;
    step: { id: string; index: number; } = { id: 'ready', index: 4 };

    constructor(
        private translateService: TranslateService,
        private log: LoggerService,
        private userService: UserService,
        private intercomService: IntercomService,
        private integrationsService: IntegrationsService,
        private snackBarService: SnackBarService
    ) {}

    ngOnInit() {
        this.userService.get(true).then(user => {
            this.teamId = user.teamId;
        });
    }
    
    chat () {
        this.intercomService.open_chat();
    }

    notify () {
        this.integrationsService.test('email-notification')
            .then(() => {
                this.snackBarService.success(this.translateService.instant('onboarding.ready.notification.sent'));
            })
            .catch(error => {
                this.log.error(error);
                this.snackBarService.error(error);
            });
    }
}
